import { useTranslation } from 'react-i18next';

import type {
  SocialCatalogIssueDetail,
  SocialCatalogItemIssue,
} from '@nucleus-commerce/api-client/admin';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@nucleus-commerce/ui/components/table';

function Details({ details }: { details: SocialCatalogIssueDetail[] }) {
  if (details.length === 0) return <span className="text-muted-foreground">—</span>;
  return (
    <ul className="flex flex-col gap-0.5">
      {details.map((detail, index) => (
        <li key={`${detail.code}-${index}`} className="font-mono text-xs">
          {detail.code}
          {detail.attribute ? (
            <span className="text-muted-foreground"> · {detail.attribute}</span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}

/** The first item issues of the last fetch, as the network reports them (variant id, codes). */
export function CatalogIssuesTable({ issues }: { issues: SocialCatalogItemIssue[] }) {
  const { t } = useTranslation('social');
  return (
    <div className="overflow-x-auto rounded-md border">
      <Table>
        <TableCaption className="sr-only">
          {t('catalog.issuesCaption', { count: issues.length })}
        </TableCaption>
        <TableHeader>
          <TableRow>
            <TableHead>{t('catalog.columns.item')}</TableHead>
            <TableHead>{t('catalog.columns.errors')}</TableHead>
            <TableHead>{t('catalog.columns.warnings')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {issues.map((issue) => (
            <TableRow key={issue.itemNumber}>
              <TableCell className="align-top">
                <span className="tabular-nums">
                  {t('catalog.itemNumber', { n: issue.itemNumber })}
                </span>
                {issue.itemId ? (
                  <span className="text-muted-foreground block font-mono text-xs break-all">
                    {issue.itemId}
                  </span>
                ) : null}
              </TableCell>
              <TableCell className="align-top">
                <Details details={issue.errors} />
              </TableCell>
              <TableCell className="align-top">
                <Details details={issue.warnings} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
